export const portfolioImages = [
  { id: 1, src: '/images/portfolio/01.jpg', title: '01' },
  { id: 2, src: '/images/portfolio/02.jpg', title: 'ladyliberty' },
  { id: 3, src: '/images/portfolio/03.jpg', title: '03' },
  { id: 4, src: '/images/portfolio/04.jpg', title: 'abstract3' },
  { id: 5, src: '/images/portfolio/05.jpg', title: '05' },
  { id: 6, src: '/images/portfolio/06.jpg', title: '06' },
  { id: 7, src: '/images/portfolio/07.jpg', title: '07' },
  { id: 8, src: '/images/portfolio/08.jpg', title: '08' },
  { id: 9, src: '/images/portfolio/09.jpg', title: '09' },
  { id: 10, src: '/images/portfolio/10.jpg', title: '10' },
  { id: 11, src: '/images/portfolio/11.jpg', title: '11' },
  { id: 12, src: '/images/portfolio/12.jpg', title: '12' },
  { id: 13, src: '/images/portfolio/13.jpg', title: '13' },
  { id: 14, src: '/images/portfolio/14.jpg', title: '14' },
  { id: 15, src: '/images/portfolio/15.jpg', title: '15' },
  { id: 16, src: '/images/portfolio/16.jpg', title: '16' },
  { id: 17, src: '/images/portfolio/17.jpg', title: '17' },
  { id: 18, src: '/images/portfolio/18.jpg', title: '18' },
  { id: 19, src: '/images/portfolio/19.jpg', title: '19' },
  { id: 20, src: '/images/portfolio/20.jpg', title: '20' },
  { id: 21, src: '/images/portfolio/21.jpg', title: '21' },
  { id: 22, src: '/images/portfolio/22.jpg', title: '22' },
  { id: 23, src: '/images/portfolio/23.jpg', title: '23' },
  { id: 24, src: '/images/portfolio/24.jpg', title: '24' },
  { id: 25, src: '/images/portfolio/25.jpg', title: '25' },
  { id: 26, src: '/images/portfolio/26.jpg', title: '26' },
  { id: 27, src: '/images/portfolio/27.jpg', title: '27' },
  { id: 28, src: '/images/portfolio/28.jpg', title: '28' },
  { id: 29, src: '/images/portfolio/29.jpg', title: '29' },
  { id: 30, src: '/images/portfolio/30.jpg', title: '30' },
  { id: 31, src: '/images/portfolio/31.jpg', title: '31' },
  { id: 32, src: '/images/portfolio/32.jpg', title: '32' },
  { id: 33, src: '/images/portfolio/33.jpg', title: '33' },
  { id: 34, src: '/images/portfolio/34.jpg', title: '34' },
  { id: 35, src: '/images/portfolio/35.jpg', title: '35' },
  { id: 36, src: '/images/portfolio/36.jpg', title: '36' },
  { id: 37, src: '/images/portfolio/37.jpg', title: '37' },
  { id: 38, src: '/images/portfolio/38.jpg', title: '38' },
  { id: 39, src: '/images/portfolio/39.jpg', title: '39' },
  { id: 40, src: '/images/portfolio/40.jpg', title: '40' },
  { id: 41, src: '/images/portfolio/41.jpg', title: '41' },
  { id: 42, src: '/images/portfolio/42.jpg', title: '42' },
  { id: 43, src: '/images/portfolio/43.jpg', title: '43' },
  { id: 44, src: '/images/portfolio/44.jpg', title: '44' },
  { id: 45, src: '/images/portfolio/45.jpg', title: '45' },
  { id: 46, src: '/images/portfolio/46.jpg', title: '46' },
  { id: 47, src: '/images/portfolio/47.jpg', title: '47' },
  { id: 48, src: '/images/portfolio/48.jpg', title: '48' },
  { id: 49, src: '/images/portfolio/49.jpg', title: '49' },
  { id: 50, src: '/images/portfolio/50.jpg', title: '50' },
  { id: 51, src: '/images/portfolio/51.jpg', title: '51' },
  { id: 52, src: '/images/portfolio/52.jpg', title: '52' },
  { id: 53, src: '/images/portfolio/53.jpg', title: '53' },
  { id: 54, src: '/images/portfolio/54.jpg', title: '54' },
  { id: 55, src: '/images/portfolio/55.jpg', title: '55' },
  { id: 56, src: '/images/portfolio/56.jpg', title: '56' },
  { id: 57, src: '/images/portfolio/57.jpg', title: '57' },
  { id: 58, src: '/images/portfolio/58.jpg', title: '58' },
  { id: 59, src: '/images/portfolio/59.jpg', title: '59' },
  { id: 60, src: '/images/portfolio/60.jpg', title: '60' },
  { id: 61, src: '/images/portfolio/61.jpg', title: '61' },
  { id: 62, src: '/images/portfolio/62.jpg', title: '62' },
  { id: 63, src: '/images/portfolio/63.jpg', title: '63' },
  { id: 64, src: '/images/portfolio/64.jpg', title: '64' },
  { id: 65, src: '/images/portfolio/65.jpg', title: '65' },
  { id: 66, src: '/images/portfolio/66.jpg', title: '66' },
  { id: 67, src: '/images/portfolio/67.jpg', title: '67' },
  { id: 68, src: '/images/portfolio/68.jpg', title: '68' },
  { id: 69, src: '/images/portfolio/69.jpg', title: '69' },
  { id: 70, src: '/images/portfolio/70.jpg', title: '70' },
  { id: 71, src: '/images/portfolio/71.jpg', title: '71' },
  { id: 72, src: '/images/portfolio/72.jpg', title: '72' },
  { id: 73, src: '/images/portfolio/73.jpg', title: '73' },
  { id: 74, src: '/images/portfolio/74.jpg', title: '74' },
  { id: 75, src: '/images/portfolio/75.jpg', title: '75' },
  { id: 76, src: '/images/portfolio/76.jpg', title: '76' },
  { id: 77, src: '/images/portfolio/77.jpg', title: '77' },
  { id: 78, src: '/images/portfolio/78.jpg', title: '78' },
  { id: 79, src: '/images/portfolio/79.jpg', title: '79' },
  { id: 80, src: '/images/portfolio/80.jpg', title: '80' },
  { id: 81, src: '/images/portfolio/81.jpg', title: '81' },
  { id: 82, src: '/images/portfolio/82.jpg', title: '82' },
  { id: 83, src: '/images/portfolio/83.jpg', title: '83' },
  { id: 84, src: '/images/portfolio/84.jpg', title: '84' },
  { id: 85, src: '/images/portfolio/85.jpg', title: '85' },
  { id: 86, src: '/images/portfolio/86.jpg', title: '86' },
  { id: 87, src: '/images/portfolio/87.jpg', title: '87' },
  { id: 88, src: '/images/portfolio/88.jpg', title: '88' },
  { id: 89, src: '/images/portfolio/89.jpg', title: '89' },
  { id: 90, src: '/images/portfolio/90.jpg', title: '90' },
  { id: 91, src: '/images/portfolio/91.jpg', title: '91' },
  { id: 92, src: '/images/portfolio/92.jpg', title: '92' },
  { id: 93, src: '/images/portfolio/93.jpg', title: '93' },
  { id: 94, src: '/images/portfolio/94.jpg', title: '94' },
  { id: 95, src: '/images/portfolio/95.jpg', title: '95' },
  { id: 96, src: '/images/portfolio/96.jpg', title: '96' },
  { id: 97, src: '/images/portfolio/97.jpg', title: '97' },
  { id: 98, src: '/images/portfolio/98.jpg', title: '98' },
  { id: 99, src: '/images/portfolio/99.jpg', title: '99' },
  { id: 100, src: '/images/portfolio/100.jpg', title: '100' },
  { id: 101, src: '/images/portfolio/101.jpg', title: '101' },
  { id: 102, src: '/images/portfolio/102.jpg', title: '102' },
  { id: 103, src: '/images/portfolio/103.jpg', title: '103' },
  { id: 104, src: '/images/portfolio/104.jpg', title: '104' },
  { id: 105, src: '/images/portfolio/105.jpg', title: '105' },
];

